/* eslint-disable monsterverse-rules/no-uuid-literals */
export const MeshAssets = {
  BedBook: "e9cd2aa9-aac1-46dd-a2fa-35924a2725dd",
};
